export abstract class MainEntitiesProvider {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  public abstract reloadEntities();
}
